import React from 'react';
import { Link } from 'react-router-dom';
import SectionLink from './SectionLink';
import FooterTechscape from './FooterTechscape';
import { getContactEmail } from '../../utils/contact';
import { MAILING_ADDRESS } from '../../utils/organization';
import logoWhite from '../../assets/images/landing/logo-white.png';

const LandingFooter = () => {
  const email = getContactEmail();
  const address = MAILING_ADDRESS.split('\n');

  return (
    <footer className="lp-footer" id="footer">
      <div className="lp-wrap">
        <div className="lp-footer-grid">
          <div>
            <img src={logoWhite} alt="Elm Business Solutions" width="195" height="72" loading="lazy" />
            <p>Technology advisory &amp; sourcing for organizations without a full-time CIO.</p>
          </div>
          <nav aria-label="Services">
            <p>Services</p>
            <Link to="/services/technology-strategy-review">Strategy Review</Link>
            <Link to="/services/technology-assessment-roadmap">Assessment &amp; Roadmap</Link>
            <Link to="/services/vcio-advisory">vCIO Advisory</Link>
            <Link to="/services/ai-automation">AI Automation</Link>
            <SectionLink id="services">Provider Sourcing</SectionLink>
          </nav>
          <nav aria-label="Company">
            <p>Company</p>
            <SectionLink id="how-we-work">How we work</SectionLink>
            <SectionLink id="who-we-serve">Who we serve</SectionLink>
            <SectionLink id="about">About</SectionLink>
            <SectionLink id="faq">FAQ</SectionLink>
            <Link to="/ringcentral">RingCentral</Link>
            <SectionLink id="contact">Contact</SectionLink>
          </nav>
          <address>
            <p>Visit</p>
            {address.map((line) => <span key={line}>{line}</span>)}
            <a href={`mailto:${email}`}>{email}</a>
          </address>
        </div>
      </div>
      <FooterTechscape />
      <div className="lp-wrap">
        <div className="lp-footer-base">
          <p>
            © {new Date().getFullYear()} Elm Business Solutions · <Link to="/privacy">Privacy</Link> · <Link to="/terms">Terms</Link>
            {' · '}<Link to="/accessibility">Accessibility</Link>
          </p>
          <p>EBS may receive compensation from technology providers or distribution partners.</p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
